import { Button, PlusIcon } from '@playerbase/ui';

import { useShell } from '../use-shell.js';

type TopbarActionsProps = {
  compact?: boolean;
};

export function TopbarActions({ compact = false }: TopbarActionsProps): JSX.Element | null {
  const { activeGame, milestones } = useShell();
  if (activeGame === null) return null;

  const compareEnabled = milestones.length >= 2;

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          disabled={!compareEnabled}
          aria-label="Compare milestones"
          title="Compare milestones"
          // TODO(milestones): open the compare-milestones modal.
          onClick={() => undefined}
        >
          ⇆
        </Button>
        <Button
          variant="primary"
          size="sm"
          aria-label="New milestone"
          title="New milestone"
          // TODO(milestones): open the new-milestone modal.
          onClick={() => undefined}
        >
          <PlusIcon />
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        disabled={!compareEnabled}
        // TODO(milestones): open the compare-milestones modal.
        onClick={() => undefined}
      >
        Compare milestones
      </Button>
      <Button
        variant="primary"
        size="sm"
        // TODO(milestones): open the new-milestone modal.
        onClick={() => undefined}
      >
        <PlusIcon />
        New milestone
      </Button>
    </div>
  );
}
